import { Icon, IconProps } from "../";

export const NiceUpIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M53.12,954.06 L47.58,959.6 C47.21,959.97 47,960.48 47,961.01 L47,971 C47,972.1 47.9,973 49,973 L58,973 C58.8,973 59.52,972.52 59.84,971.79 L63.1,964.18 C63.94,962.2 62.49,960 60.34,960 L54.69,960 L55.64,955.42 C55.74,954.92 55.59,954.41 55.23,954.05 C54.64,953.47 53.7,953.47 53.12,954.06 Z M43,973 C44.1,973 45,972.1 45,971 L45,963 C45,961.9 44.1,961 43,961 C41.9,961 41,961.9 41,963 L41,971 C41,972.1 41.9,973 43,973 Z"
        transform="translate(-40 -952)"
      />
    </Icon>
  );
};
